/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { LIVE_TV_LOCATION_RESTRICTION_OSD_PRIORITY } from '../../../config';
import { ErrorTypes } from '../../error';
import { Locale } from '../../locale/Locale';
import { LocaleKeys } from '../../locale/LocaleKeys';
import { Log } from '../../logging';
import { VisualDisplayTypes } from '../enums';
import { LiveTvErrorBase } from './LiveTvErrorBase';

export class LiveTvLocationError extends LiveTvErrorBase {
    TAG: string = 'LiveTvLocationError';

    public processErrorByCode(error: any) {
        Log.d(this.TAG, 'process Playback Error', error);
        switch (error.getCode()) {
            case ErrorTypes.LIVE_TV_LOCATION_RESTRICTION_OSD_ERROR_CODE_V418:
                this.uiVisualType = VisualDisplayTypes.OSD;
                this.priority = LIVE_TV_LOCATION_RESTRICTION_OSD_PRIORITY;
                this.description = Locale.getString(
                    LocaleKeys.LIVE_TV_LOCATION_RESTRICTION_OSD_MESSAGE,
                );
                this.uiErrorCode = error.getCode();
                break;

            default:
                break;
        }
    }
}
